<pgh-modal-window size="md" *ngIf="modalData != null">
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-body style="display:flex;">
    <div class="no-devices-info-container"><mat-icon style="height:64px;width:64px;overflow:visible !important;margin-top:10px;"><ng-container *ngTemplateOutlet="infoIcon">
    </ng-container></mat-icon></div>
    <div>
      <div modal-title style="color:#596981;font-weight: 600;font-size: 14px;">
        <adp-label labelKey="Global_Modal_NoDevices_Title"></adp-label>
      </div>
      <div class="mb-20" style="font-weight:700;color:#13223C;font-size:24px;">
        <h4 style="font-weight:600;"><adp-label labelKey="Global_Modal_NoDevices_Subtitle"></adp-label></h4>
      </div>
    </div>
  </div>

  <div modal-body [innerHTML]="getLabel('Global_Modal_NoDevices_Description')" style="font-size:18px;font-weight: 18px;color:#13223C;"></div>

  <div modal-footer style="display:flex;justify-content: right;" class="row">
    <div class="col-md-6">
      <!--<button mat-stroked-button color="primary" class="border-0" (click)="onCancelClicked()">
        <adp-label labelKey="Global_Button_Cancel"></adp-label>
      </button>-->
    </div>
    <div class="col-md-6">
      <button style="min-width: 250px !important;" mat-flat-button matDialogClose color="accent" (click)="addMyDevices()">
        <adp-label labelKey="Global_Modal_NoDevices_ButtonText"></adp-label>
      </button>
    </div>
  </div>
</pgh-modal-window>

<ng-template #infoIcon>
  <svg width="134" height="134" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 15.5C12.1727 15.5 11.5 14.8273 11.5 14V11.5H11C10.724 11.5 10.5 11.276 10.5 11C10.5 10.724 10.724 10.5 11 10.5H11.5C12.0513 10.5 12.5 10.9487 12.5 11.5V14C12.5 14.276 12.724 14.5 13 14.5H13.5C13.776 14.5 14 14.724 14 15C14 15.276 13.776 15.5 13.5 15.5H13Z" fill="currentColor"/>
    <path d="M11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5Z" fill="currentColor"/>
    <path d="M12 20C7.58867 20 4 16.4113 4 12C4 7.58867 7.58867 4 12 4C16.4113 4 20 7.58867 20 12C20 16.4113 16.4113 20 12 20ZM12 5C8.14 5 5 8.14 5 12C5 15.86 8.14 19 12 19C15.86 19 19 15.86 19 12C19 8.14 15.86 5 12 5Z" fill="currentColor"/>
  </svg>
</ng-template>
